module.exports = __webpack_public_path__ + "img/CRT_Weapon-Wand-02.f1ecd1c9.png";